/* React core */
import { Component } from "react"

/* Selected map provider from env */
import { mapProvider } from "../constants/env"
/* Yandex map implementation */
import MapYandex from "./maps/MapYandex"
/* 2GIS map implementation */
import Map2gis from "./maps/Map2gis"

/* Component MapView */
class MapView extends Component {

    render = () => {
        if (mapProvider === "2gis") {
            return <Map2gis items={this.props.items} onSelect={this.props.onSelect} />
        }
        return <MapYandex items={this.props.items} onSelect={this.props.onSelect} />
    }
}

/* Export */
export default MapView
